// extracted by mini-css-extract-plugin
export var boxPara = "sectionImageCards-module--box-para--0b16e";
export var boxTitle = "sectionImageCards-module--box-title--ea6bc";
export var button = "sectionImageCards-module--button--43b18";
export var cafeFormIntro = "sectionImageCards-module--cafe-form-intro--b033a";
export var card = "sectionImageCards-module--card--026d2";
export var cardBox = "sectionImageCards-module--card-box--fcffe";
export var cardDetail = "sectionImageCards-module--card-detail--f0e7b";
export var cardImage = "sectionImageCards-module--card-image--c76fa";
export var cardWrapper = "sectionImageCards-module--card-wrapper--309cb";
export var highlight = "sectionImageCards-module--highlight--829f6";
export var imageCardTitle = "sectionImageCards-module--image-card-title--01f29";
export var redButton = "sectionImageCards-module--red-button--a8d95";
export var redTransparentButton = "sectionImageCards-module--red-transparent-button--7f9e5";
export var transparentButton = "sectionImageCards-module--transparent-button--4751c";